import gsap from "gsap";

import Masonry from "masonry-layout";

document.querySelectorAll(".js-news-page").forEach((el) => {
	const title = el.querySelector(".js-title"),
		text = el.querySelector(".js-text"),
		animatable_els = el.querySelectorAll(".js-animate");

	gsap.fromTo(
		[title, text, animatable_els],
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			delay: 0.4,
			stagger: 0.1,
		},
	);

	// masonry

	let masonry_array = [];

	window.masonry_array = masonry_array;

	if (window.matchMedia("(min-width: 769px)").matches) {
		el.querySelectorAll(".masonry-grid").forEach((grid) => {
			masonry_array.push(
				new Masonry(grid, {
					itemSelector: ".masonry-grid__item",
					horizontalOrder: true,
				}),
			);
		});
	}

	// tabs rework

	let active_tab = 0;

	let is_animating = false;

	const tab_buttons = el.querySelectorAll(".js-tab-toggle");

	const tabs_content = el.querySelectorAll(".js-tabs__tab");

	// const tabs_outer_el = el.querySelector(".js-tabs");

	tab_buttons.forEach((button, index) => {
		button.addEventListener("click", () => {
			if (index !== active_tab && !is_animating) {
				is_animating = true;

				// animate out
				tab_buttons[active_tab].classList.remove("active");

				// tabs_content[active_tab].classList.add("hidden");
				tabs_content[active_tab].classList.remove("active");

				gsap.delayedCall(0.3, () => {
					tabs_content[active_tab].classList.add("hidden");

					active_tab = index;

					tabs_content[index].classList.add("active");

					is_animating = false;
				});

				button.classList.add("active");

				// active_tab = index;

				tabs_content[index].classList.remove("hidden");
				// tabs_content[index].classList.add("active");

				// animate height ?

				masonry_array[index].resize();
			}
		});
	});
});
